import styled from 'styled-components';

import { FormBuilderSubmitButtonWrapperStyled } from './FormBuilderSubmitButton.types';

export const FormBuilderSubmitButtonWrapper = styled.div<FormBuilderSubmitButtonWrapperStyled>`
  margin: 16px auto auto;
  width: ${({ fullWidth }) => (fullWidth ? '100%' : 'unset')};
`;
